import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllPoyer,
  GetAllStatusEligibility,
  GetEligibilityCheckList,
  GetPatientDetails,
  GetPayerInsurance,
  GetSingleEligibilityData,
} from "./eligibilityCheckListApi";
import { getToday } from "helpers/utils";

const initialState = {
  poyerList: [],
  patientDetails: [],
  eligibilityCheckList: [],
  payerInsurance: [],
  singleEliginilityData: null,
  eligibilityFilters: {
    payer: "",
    insurance_company: "",
    patient: "",
    identifier_type: "",
    start_date: getToday(),
    end_date: getToday(),
    status: "",
  },
};

const eligibilityCheckListSlice = createSlice({
  name: "eligibilityCheckList",
  initialState,
  reducers: {
    handleElibilityFilter: (state, action) => {
      state.eligibilityFilters[action?.payload?.check] = action?.payload?.value;
    },

    handleResetFilter: (state, { payload }) => {
      state.eligibilityFilters = {
        payer: "",
        insurance_company: "",
        patient: "",
        singleEligibilityData: null,
        identifier_type: "",
        start_date: getToday(),
        end_date: getToday(),
        status: "",
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPoyer.fulfilled, (state, action) => {
        state.poyerList = action.payload?.data?.payer_id;
      })
      .addCase(GetPatientDetails.fulfilled, (state, action) => {
        state.patientDetails = action.payload?.data?.patient_data || [];
      })
      .addCase(GetEligibilityCheckList.fulfilled, (state, action) => {
        state.eligibilityCheckList =
          action.payload?.data?.eligibilitycheck_data;
      })
      .addCase(GetPayerInsurance.fulfilled, (state, action) => {
        state.payerInsurance = action.payload?.data?.inspay_data;
      })
      .addCase(GetAllStatusEligibility.fulfilled, (state, action) => {
        state.allStatusList = action.payload?.data?.allstatus_data;
      })
      .addCase(GetSingleEligibilityData.fulfilled, (state, action) => {
        state.singleEligibilityData = action.payload?.data;
      });
  },
});

export const { handleResetFilter, handleElibilityFilter } =
  eligibilityCheckListSlice.actions;

export default eligibilityCheckListSlice.reducer;
